import { dialogQueue } from 'src/components/dialog';
import { clearCartTableId, clearTable, getTable, setTable } from 'src/utils/common';
import IndexDialog from '../components/dialog/index.vue'
import { ADD_SUCCESS_RECOMMEND } from './config';

const CODE_MSG = {
  500: 'INTERNAL_SERVER_ERROR',
  311: 'min_selection_error',
  312: 'max_selection_error',
  314: 'Product id is not sellable!',
  300: 'CART_EMPTY',
  301: 'product_changed',
  302: 'not_in_live',
  303: 'out_of_product_stock',
  304: 'CART_ITEM_NOT_IN_LIST',
  305: 'modifier_changed',
  307: 'out_of_modifier_option_stock',
  309: 'modifier_illegal',
  315: 'PACKAGE_BASE_GROUP_INVALID', // 套餐基本组无效
  316: 'CART_PACKAGE_OPTION_GROUP_INVALID', // 套餐可选件组无效
  317: 'CART_PACKAGE_GROUP_TYPE_INVALID', // 套餐基本组无效
  322: 'CART_ITEM_OUT_OF_SERVICE', // 购物车中不支持的服务类型商品
  323: 'CART_ITEM_BUNDING_ONLY', // 购物车商品不可单独售卖
  507: 'InvalidPhone', // OVO手机号校验失败
  515: 'scheduled_order_time_not_available', // 预订单时间不可用
  600: 'productStoreId_is_null',
  514: 'tableNumber_is_illegal',
  803: 'voucher_invalid', // 优惠券无效
  511: 'CHECKOUT_SERVICE_TYPE_INVALID', // 服务类型不可用
  710: 'PROD_STOCK_INVALID', // 产品库存不合法
  // full dine in
  516: 'CHECKOUT_DUPLICATE_PAYMENT', // 重复支付
  413: 'ORDER_UPDATED', // 订单锁操作code
  415: 'ORDER_ITEM_PROCESSING_CANT_PAY', // 订单中还有为完成的商品
  616: 'STORE_FULL_DINE_IN_UNSERVICEABLE', // full dine in 不可用
  408: 'ORDER_STATUS_CANCELLED', // 订单以取消
  411: 'ORDER_STATUS_COMPLETED', // 订单以完成
  416: 'ORDER_PAID', // 订单已支付
  417: 'ORDER_GRAND_TOTAL_ZERO_CANT_PAY', // 支付时价格为0
  815: 'PROMO_OUT_OF_STOCK', // 促销卖完（may delivery）
  513: 'CHECKOUT_PAYMENT_ID_INVALID', // 非法支付方式
  816: 'PROMO_PRICE_DISCOUNT_OVERUSE', // 商品折扣优惠有变动（超额）
  817: 'PROMO_PRICE_DISCOUNT_NO_QUOTA', // 商品折扣优惠用完了
  // 换桌中，操作的3个限制
  319: 'CART_ADD_ITEM_FAILED_BY_CHANGING_TABLE', // 因换桌购物车无法添加商品
  517: 'TABLE_CHANGED', // 换桌没收到通知，下单和加购的限制
  418: 'ORDER_FAILED_BY_CHANGING_TABLE', // 因换桌无法下单
  726: 'PROD_BUNDING_ONLY', // 产品仅限套餐中使用
  727: 'PROD_OUT_OF_SERVICE', // 产品本渠道无效

  // ======NOT_API_CODE=======
  8001: 'ERROR_SCHEDULE_TIME', // 预订单时间不合法
  8002: 'EMAIL_IS_REQUIRED', // 邮箱是必须的
  8003: 'NOT_SUPPORT_TABLE', // 桌号不可用
  8004: 'TABLE_CHANGED', // 换桌成功 success
  8005: 'TABLE_CHANGED_TARGET', // 换桌成功 clear 对目标桌子发送的通知
  8006: 'STORE_IS_CLOSE', // 店铺关闭弹窗提示
}

function refresh() {
  window.location.reload();
}
function backToList(vm) {
  vm.$router.replace({ name: 'products-list' });
}
function backToCart(vm) {
  if (vm?.$route.name === 'cart') {
    vm.reload();
  } else {
    vm.$router.replace({ name: 'cart' });
  }
}
function backToHome(vm) {
  vm.$router.replace({ name: 'home' });
  refresh();
}
function backToOnGo(vm) {
  vm.$router.replace({ name: 'OnGoing', query: { orderId: vm.fullDineInOrderId } })
}

export const getConfig = (vm, code, callbackPayload) => {
  const table = callbackPayload || getTable();
  const config = {
    ORDER_FAILED_BY_CHANGING_TABLE: {
      customIcon: 'https://static.bakmigm.co.id/menu/full_dine_change_table_icon_2023_02_17.png',
      title: vm.$t('fullDinein.tableChangedOrderTitle'),
      describe: vm.$t('fullDinein.tableChangedOrderDesc'),
      ok: 'OK',
      callback() { }
    },
    CHECKOUT_FAILED_BY_CHANGING_TABLE: {
      customIcon: 'http://static.bakmigm.co.id/menu/full_dine_change_table_icon_2023_02_17.png',
      title: vm.$t('fullDinein.tableChangedCheckoutTitle'),
      describe: vm.$t('fullDinein.tableChangedCheckoutDesc'),
      ok: 'OK',
      callback() { }
    },
    CART_ADD_ITEM_FAILED_BY_CHANGING_TABLE: {
      title: vm.$t('fullDinein.tableChagingNotAddToCartTitle'),
      describe: vm.$t('fullDinein.tableChagingNotAddToCartDesc'),
      ok: 'OK',
      callback: vm.$reload
    },
    TABLE_CHANGED: {
      customIcon: 'http://static.bakmigm.co.id/menu/full_dine_change_table_icon_2023_02_17.png',
      title: vm.$t('fullDinein.tableChangedOriginTitle', { table }),
      ok: 'OK',
      callback(vm2, payload) {
        if (payload) setTable(payload);
        clearCartTableId();
        setTimeout(refresh, 500);
      }
    },
    TABLE_CHANGED_TARGET: {
      customIcon: 'https://static.bakmigm.co.id/menu/changed_table_for_target_2023_0220.png',
      title: vm.$t('fullDinein.tableChangedTargetTitle'),
      ok: 'OK',
      callback: refresh
    },
    INTERNAL_SERVER_ERROR: {
      title: 'Internal Server Error',
      ok: 'OK',
      callback: vm.reload
    },
    CART_ITEM_OUT_OF_STOCK: {
      title: vm.$t('details.inventoryChange'),
      ok: 'OK',
      callback: backToCart,
    },
    CART_ITEM_NOT_IN_LIST: {
      title: vm.$t('details.undercarriage'),
      ok: 'OK',
      callback: backToCart,
    },
    CART_ITEM_OUT_OF_SERVICE: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      callback: () => {
        backToCart(vm);
      }
    },
    CART_ITEM_BUNDING_ONLY: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      callback: () => {
        backToCart(vm);
      }
    },
    CART_EMPTY: {
      title: vm.$t('details.cartEmpty'),
      ok: 'OK',
      callback: backToCart,
    },
    min_selection_error: {
      title: vm.$t('details.chooseVariant'),
      ok: 'OK',
      callback: refresh,
    },
    max_selection_error: {
      title: vm.$t('details.chooseVariant'),
      ok: 'OK',
      callback: refresh,
    },
    out_of_stock: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg1'),
      ok: 'OK',
      callback: backToCart,
    },
    not_in_live: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg2'),
      ok: 'OK',
      callback: backToCart,
    },
    modifier_changed: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg4'),
      ok: 'OK',
      callback: backToCart,
    },
    option_illegal: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg3'),
      ok: 'OK',
      callback: backToCart,
    },
    product_changed: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      callback: backToCart
    },
    out_of_product_stock: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg5'),
      ok: 'OK',
      callback: backToCart,
    },
    out_of_modifier_option_stock: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg6'),
      ok: 'OK',
      callback: backToCart,
    },
    modifier_illegal: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg4'),
      ok: 'OK',
      callback: backToCart,
    },
    // checkout服务类型变动
    CHECKOUT_SERVICE_TYPE_INVALID: {
      title: vm.$t('fullDinein.serviceableTip'),
      ok: 'OK',
      callback: backToHome
    },
    // full dine in
    // 重复支付
    CHECKOUT_DUPLICATE_PAYMENT: {
      title: vm.$t('fullDinein.duplicatePayTip'),
      ok: 'OK',
      callback() {
        if (vm.isFullDineIn) {
          vm.$router.replace({ name: 'OnGoing', query: { orderId: vm.fullDineInOrderId } })
        } else {
          vm.$router.replace({ name: 'products-list' });
        }
      },
    },
    // 订单锁code
    ORDER_UPDATED: {
      title: vm.$t('fullDinein.systemBusyTip'),
      ok: 'OK',
      callback: refresh,
    },
    // 订单中还有未完成的商品
    ORDER_ITEM_PROCESSING_CANT_PAY: {
      title: vm.$t('fullDinein.orderProcessingTip'),
      ok: 'OK',
      callback: backToOnGo
    },
    // fulldienin 不可用
    STORE_FULL_DINE_IN_UNSERVICEABLE: {
      title: vm.$t('fullDinein.serviceableTip'),
      ok: 'OK',
      callback() {
        vm.$router.replace({ name: 'home' })
      }
    },
    // 订单已支付
    ORDER_PAID: {
      title: vm.$t('fullDinein.orderCheckingTip'),
      ok: 'OK',
      callback: backToOnGo
    },
    // 订单已取消
    ORDER_STATUS_CANCELLED: {
      title: vm.$t('fullDinein.orderCanceledTip'),
      ok: 'OK',
      callback: backToOnGo
    },
    // 订单已完成
    ORDER_STATUS_COMPLETED: {
      title: vm.$t('fullDinein.orderCompletedTip'),
      ok: 'OK',
      callback: backToOnGo
    },
    PACKAGE_BASE_GROUP_INVALID: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg4'),
      ok: 'OK',
      callback: backToCart,
    },
    CART_PACKAGE_OPTION_GROUP_INVALID: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg4'),
      ok: 'OK',
      callback: backToCart,
    },
    CART_PACKAGE_GROUP_TYPE_INVALID: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg4'),
      ok: 'OK',
      callback: backToCart,
    },
    CART_MODIFIER_INVALID: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg4'),
      ok: 'OK',
      callback: backToCart,
    },
    tableNumber_is_illegal: {
      title: vm.$t('fullDinein.illegalTable'),
      ok: 'OK',
      callback() {
        clearTable();
        backToHome(vm);
      },
    },
    ORDER_GRAND_TOTAL_ZERO_CANT_PAY: {
      title: vm.$t('checkout.zorepayTip'),
      ok: 'OK',
      callback: backToCart
    },
    InvalidPhone: {
      title: vm.$t('checkout.checkoutOvoPhone'),
      ok: vm.$t('checkout.changeNumberBtn'),
      callback() { }
    },
    ERROR_SCHEDULE_TIME: {
      title: vm.$t('checkout.errorScheduleTime', { type: vm.accessStatus }),
      ok: 'OK',
      callback: vm.reload
    },
    EMAIL_IS_REQUIRED: {
      title: vm.$t('checkout.requiredEmailTip'),
      ok: 'OK',
      callback: vm.reload
    },
    scheduled_order_time_not_available: {
      title: vm.$t('checkout.errorScheduleTime', {
        type: vm.accessStatus,
      }),
      ok: 'OK',
      callback: vm.reload
    },
    PROMO_OUT_OF_STOCK: {
      title: '',
      ok: 'OK',
      callback: vm.reload
    },
    voucher_invalid: {
      title: vm.$t('checkout.promoInvalid'),
      ok: 'OK',
      callback: vm.reload
    },
    NOT_SUPPORT_TABLE: {
      title: (function () {
        const v1 = vm.$t(`list.table${vm.storeInfo.businessType}`);
        const v2 = getTable();
        return vm.$t('componentsBaseDialog.payTableNotFound', { v1, v2 });
      }()),
      ok: 'OK',
      callback() {
        clearTable();
        backToHome(vm);
      }
    },
    CHECKOUT_PAYMENT_ID_INVALID: {
      title: vm.$t('checkout.invalidPayment'),
      ok: 'OK',
      callback: vm.reload
    },
    PROMO_PRICE_DISCOUNT_OVERUSE: {
      title: vm.$t('checkout.promoTip816'),
      ok: vm.$t('checkout.okText816'),
      cancel: vm.$t('checkout.cancelText816'),
      callback() {
        vm.$store.dispatch('prefetch/getCartDetails', {});
        vm.$nextTick(() => vm.reload())
      },
      onCancel() {
        vm.$store.dispatch('prefetch/getCartDetails', {});
        vm.$nextTick(() => backToCart(vm));
      }
    },
    PROMO_PRICE_DISCOUNT_NO_QUOTA: {
      title: vm.$t('checkout.promoTip817'),
      ok: vm.$t('checkout.okText816'),
      cancel: vm.$t('checkout.cancelText816'),
      callback() {
        vm.$store.dispatch('prefetch/getCartDetails', {});
        vm.$nextTick(() => vm.reload())
      },
      onCancel() {
        vm.$store.dispatch('prefetch/getCartDetails', {});
        vm.$nextTick(() => backToCart(vm));
      }
    },
    STORE_IS_CLOSE: {
      title: vm.$t('common.storeCloseDialogTitle'),
      type: 'info',
      ok: 'OK',
      callback() { }
    },
    PROD_BUNDING_ONLY: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      callback: () => {
        backToCart(vm);
      }
    },
    PROD_OUT_OF_SERVICE: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      callback: () => {
        backToCart(vm);
      }
    },
    PROD_STOCK_INVALID: {
      title: vm.$t('componentsBaseDialog.productDetailsErrorMsg7'),
      ok: 'OK',
      callback: backToCart,
    }
  }
  return config[CODE_MSG[code]]
}
export function showDialog(vm, code, props = {}, { secondTile, callbackPayload } = {}) {
  const config = getConfig(vm, code, callbackPayload);
  if (!config) {
    return console.warn(`[PATH: ${vm.$route.name}]\n [CODE: ${code}] error config is empty!`);
  }
  const { customIcon, ...other } = props;
  const dialog = vm.$q.dialog({
    component: IndexDialog,
    parent: vm,
    title: config.title || secondTile,
    describe: config.describe,
    ok: config.ok,
    cancel: config.cancel,
    customIcon: customIcon || config.customIcon,
    type: config.type,
    ...other
  }).onOk(() => {
    config.callback(vm, callbackPayload);
  }).onCancel(() => {
    config.onCancel(vm, callbackPayload);
  })
  dialogQueue.push(dialog);
  return dialog;
}
export function needJumoToCartConfirm(code) {
  return code === 301 || code === 305;
}
